module.exports = __webpack_public_path__ + "static/media/welcome4.1ee0f3d3.png";